//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import foretell from "~/mixins/foretell.js";
import aos from "~/mixins/aos.js";
import orderCreatable from "~/mixins/orderCreateable.js";
import API from "~/api/api";
import { directive as onClickaway } from "vue-clickaway2";
import schemaHelpers from "~/mixins/schema-helpers.js";

export default {
  layout: "default-no-sticky",
  watch: {},
  mixins: [foretell, orderCreatable, aos, schemaHelpers],
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      selectedEntity: "LLC",
      showEntitySelector: false,
      showAllDocs: false,
      showAllServices: false,
      activeDocs: "popular",
      companyName: "",
      showModal: false,
    };
  },
  methods: {
    getActiveDocs() {
      if (this.activeDocs === "popular") return this.popularDocuments;
      else if (this.activeDocs === "hr") return this.hrDocuments;
      else if (this.activeDocs === "sales") return this.salesDocuments;
      else if (this.activeDocs === "formation") return this.formationDocuments;
      else if (this.activeDocs === "website") return this.websiteDocuments;
      else if (this.activeDocs === "other") return this.otherDocuments;
    },
    goToPage(page) {
      window.location.href = page;
    },
    scrollTo(target) {
      let el = document.querySelector(target);

      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    ViewBFDocs() {
      this.ShowMoreBFDocs = !this.ShowMoreBFDocs;
      if (this.ShowMoreBFDocs) this.ShowBFDocs = this.BFDocs.length;
      else this.ShowBFDocs = 9;
    },
  },
  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/business";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  jsonld() {
    if (this.pageInfo) {
      return [
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "https://www.legalnature.com/business",
          },
          headline: this.metaInfo.title,
          description: this.metaInfo.description,
          image: this.metaInfo["og-image"],
          url: "https://www.legalnature.com/business",
          author: this.schemaAuthor,
          logo: this.schemaLogo,
          publisher: {
            "@type": "Organization",
            name: "LegalNature",
            logo: this.schemaLogo,
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Homepage",
              item: "https://www.legalnature.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Business",
              item: "https://www.legalnature.com/business",
            },
          ],
        },
      ];
    }
  },

  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:business",
      });
    }
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "copy-business-new2", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },
  computed: {
    ctaText() {
      if (this.selectedEntity === "LLC") return "Start an LLC";
      else return `Start a ${this.selectedEntity}`;
    },
    hasSubscriptionAccess() {
      return this.$store.state.user.data.subscriptionAccess;
    },
    hero() {
      if (this.pageInfo.fields.hero) return this.pageInfo.fields.hero;
    },
    formation() {
      if (this.pageInfo.fields.formation) return this.pageInfo.fields.formation;
      else return false;
    },
    manage() {
      if (this.pageInfo.fields.manage) return this.pageInfo.fields.manage;
      else return false;
    },
    ra() {
      if (this.pageInfo.fields.registered_agent)
        return this.pageInfo.fields.registered_agent;
      else return false;
    },
    cg() {
      if (this.pageInfo.fields.compliance_guard)
        return this.pageInfo.fields.compliance_guard;
      else return false;
    },
    documents() {
      if (this.pageInfo.fields.documents) return this.pageInfo.fields.documents;
      else return false;
    },
    footerCta() {
      if (this.pageInfo.fields.footer_cta)
        return this.pageInfo.fields.footer_cta;
      else return false;
    },
    resources() {
      if (this.pageInfo.fields.resources_new)
        return this.pageInfo.fields.resources_new;
      else return false;
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
    popularDocuments() {
      let docs = [
        {
          name: "LLC Operating Agreement",
          url: "/categories/business-formation/llc-operating-agreement",
          description: "Set the ground rules for your LLC",
          icon: "launch",
        },
        {
          name: "Articles of Organization",
          url: "/categories/business-formation/articles-of-organization",
          description:
            "A necessary part of creating a limited liability company.",
          icon: "agreement",
        },
        {
          name: "Banking Resolution",
          url: "/categories/business-formation/banking-resolution",
          description:
            "The simplest way for a company to authorize opening a bank account.",
          icon: "bank",
        },
        {
          name: "Employee Handbook",
          url: "/categories/business-formation/employee-handbook",
          description: "Guides employees on your policies and procedures.",
          icon: "instructions",
        },
        {
          name: "Non-Disclosure Agreement",
          url: "/categories/human-resources/non-disclosure-agreement",
          description:
            "Prohibits from disclosing confidential information or trade secrets to others.",
          icon: "doc-sign",
        },
        {
          name: "Meeting Minutes",
          url: "/categories/business-formation/meeting_minutes",
          description:
            "Official records of an organization and are legally required for corporate meetings.",
          icon: "agreement",
        },
        {
          name: "General Services Agreement",
          url: "/categories/business/general-services-agreement",
          description: "Define the relationship between 2 entities.",
          icon: "default",
        },
        {
          name: "Employment Contract",
          url: "/categories/human-resources/employment-contract",
          description:
            "Establish the goals, expectations, and financial benefits.",
          icon: "corporate",
        },
      ];
      return docs;
    },
    formationDocuments() {
      let docs = [
        {
          name: "Articles of Organization",
          url: "/categories/business-formation/articles-of-organization",
          description:
            "A necessary part of creating a limited liability company.",
          icon: "launch",
        },
        {
          name: "LLC Operating Agreement",
          url: "/categories/business-formation/llc-operating-agreement",
          description: "Set the ground rules for your LLC.",
          icon: "launch",
        },
        {
          name: "Articles of Incorporation",
          url: "/categories/business-formation/articles-of-incorporation",
          description: "A necessary part of creating a corporation.",
          icon: "launch",
        },
        {
          name: "Corporate Bylaws",
          url: "/categories/business-formation/corporate-bylaws",
          description:
            "Corporate bylaws are a set of rules and procedures used to determine how a C corp, S corp, or nonprofit will be run.",
          icon: "doc-sign",
        },
        {
          name: "Partnership Agreement",
          url: "/categories/business-formation/partnership-agreement",
          description:
            "Defines how a partnership will function, how decisions will be made, and each partner's role in the business.",
          icon: "agreement",
        },
        {
          name: "Business Plan",
          url: "/categories/business-formation/business-plan",
          description:
            "Outlines your company's operations, marketing, and financial strategy for potential investors or partners.",
          icon: "instructions",
        },
        {
          name: "LLC Operating Agreement Amendment",
          url:
            "/categories/business-formation/llc-operating-agreement-amendment",
          description: "Updates your existing LLC operating agreement.",
          icon: "doc-sign",
        },
        {
          name: "LLC Operating Agreement Addendum",
          url:
            "/categories/business-formation/llc-operating-agreement-addendum",
          description:
            "Allows you to adds new terms to the LLC's current operating agreement.",
          icon: "doc-sign",
        },
      ];
      return docs;
    },
    salesDocuments() {
      let docs = [
        {
          name: "Bill of Sale",
          url: "/categories/business/bill-of-sale",
          description:
            "Documents the important details of a transaction and serves as evidence of legal transfer of title.",
          icon: "default",
        },
        {
          name: "Purchase Agreement",
          url: "/categories/business/purchase-agreement",
          description:
            "A legally binding contract between a buyer and seller that covers the buying and selling of goods.",
          icon: "agreement",
        },
        {
          name: "Sales Contract",
          url: "/categories/business/sales-contract",
          description:
            "Record the important terms of your transaction and provide you with thorough protection. ",
          icon: "doc-sign",
        },
        {
          name: "Sale of Goods Agreement",
          url: "/categories/business/sale-of-goods-agreement",
          description:
            "Legally binding contract between a buyer and seller that covers the buying and selling of goods.",
          icon: "agreement",
        },
      ];
      return docs;
    },
    websiteDocuments() {
      let docs = [
        {
          name: "Online Terms and Conditions",
          url: "/categories/business/online-terms-and-conditions",
          description:
            "Websites must provide their terms and conditions so that their visitors are aware of the rules for using the site.",
          icon: "doc-sign",
        },
        {
          name: "Software License Agreement",
          url: "/categories/business/software-license-agreement",
          description:
            "For any business that gives its users access to its software, a software license agreement is absolutely essential to protect your rights.",
          icon: "agreement",
        },
        {
          name: "Website Terms of Use",
          url: "/categories/business/terms-of-use",
          description:
            "Your website terms of use will allow you to set up rules and regulations for your visitors using your website.",
          icon: "instructions",
        },
        {
          name: "Website Privacy Policy",
          url: "/categories/business/website-privacy-policy",
          description:
            "Websites are required to display privacy policies in order to notify visitors of how their personal information is collected, used, and shared.",
          icon: "default",
        },
      ];
      return docs;
    },
    hrDocuments() {
      let docs = [
        {
          name: "Consulting Services Agreement",
          url: "/categories/business-formation/consulting-services-agreement",
          description:
            "Defines the terms of service and governs the relationship between a client and consultant.",
          icon: "agreement",
        },
        {
          name: "Employee Handbook",
          url: "/categories/business-formation/employee-handbook",
          description:
            "Guides employees on their employer's policies and procedures concerning the important aspects of employment.",
          icon: "instructions",
        },
        {
          name: "Employment Contract",
          url: "/categories/human-resources/employment-contract",
          description:
            " Establish the goals, expectations, and financial benefits that make up the relationship between the employee and employer.",
          icon: "corporate",
        },
        {
          name: "Employment Offer Letter",
          url: "/categories/business-formation/employment-offer-letter",
          description:
            "Specify all the relevant details of employment, including start date, job duties, compensation, and more.",
          icon: "agreement",
        },
        {
          name: "Employment Termination Letter",
          url: "/categories/human-resources/employment-termination-letter",
          description:
            "A formal document issued by an employer to notify an employee about the termination of their employment.",
          icon: "doc-sign",
        },
        {
          name: "Employment Verification Letter",
          url: "/categories/human-resources/staff-confirmation-letter",
          description:
            "An employment verification letter is a document that confirms the employment status of an employee.",
          icon: "default",
        },
        {
          name: "Independent Contractor Agreement",
          url:
            "/categories/business-formation/independent-contractor-agreement",
          description:
            "Sets forth the essential terms of the business relationship between a contractor and a client.",
          icon: "agreement",
        },
        {
          name: "Job Offer Letter",
          url: "/categories/business-formation/job-offer-letter",
          description:
            "Using well-crafted job offer letters is an effective recruiting strategy that can give a company the edge in a competitive hiring environment.",
          icon: "default",
        },
        {
          name: "Letter of Resignation",
          url: "/categories/business-formation/letter-of-resignation",
          description:
            "Formally notify to your organization that you are leaving your position.",
          icon: "default",
        },
        {
          name: "Letter of Recommendation",
          url: "/categories/business-formation/letter-of-recommendation",
          description:
            "Formal letter often used to describe qualities, strengths, and characteristics of another person",
          icon: "corporate",
        },
        {
          name: "Non-Compete Agreement",
          url: "/categories/human-resources/non-compete-agreement",
          description:
            "Restrict competition between a business and its employees, contractors, or other businesses with which it deals.",
          icon: "agreement",
        },
        {
          name: "Non-Disclosure Agreement",
          url: "/categories/human-resources/non-disclosure-agreement",
          description:
            "Prohibits an individual or business from disclosing confidential information or trade secrets to others.",
          icon: "agreement",
        },
      ];
      return docs;
    },
    otherDocuments() {
      let docs = [
        {
          name: "Arbitration Agreement",
          url: "/categories/business/arbitration-agreement",
          description:
            "Sets up a dispute resolution process for existing or future disputes between two parties.",
          icon: "agreement",
        },
        {
          name: "Banking Resolution",
          url: "/categories/business-formation/banking-resolution",
          description:
            "The simplest way for a company to authorize opening a bank account.",
          icon: "doc-sign",
        },
        {
          name: "General Services Agreement",
          url: "/categories/business/general-services-agreement",
          description:
            "Defines the relationship between the business providing a service and the client receiving the service.",
          icon: "agreement",
        },
        {
          name: "Contract Amendment",
          url: "/categories/business/contract-amendment",
          description:
            "Use our contract amendment template to quickly modify, delete, or add terms to a prior contract.",
          icon: "default",
        },
        {
          name: "Corporate Resolution",
          url: "/categories/business-formation/corporate-resolution",
          description:
            "A corporate resolution formally records any major decision made by a corporation, LLC or nonprofit.",
          icon: "doc-sign",
        },
        {
          name: "Hold Harmless Agreement",
          url: "/categories/business/hold-harmless-agreement",
          description:
            "Limit your legal and financial liability for injuries or damages.",
          icon: "agreement",
        },
        {
          name: "Indemnity Agreement",
          url: "/categories/business/indemnity-agreement",
          description:
            "Limit your liability during any transaction for any claims brought by a third party.",
          icon: "agreement",
        },
        {
          name: "Investment Agreement",
          url: "/categories/business/investment-agreement",
          description:
            "Outlines the terms and conditions of a deal between someone who wants to invest money in a business or project and the person or entity who owns or runs it.",
          icon: "agreement",
        },
        {
          name: "Loan Agreement",
          url: "/categories/business/loan-agreement",
          description:
            "Use our loan agreement template to specify all the important terms and conditions for repayment of a loan.",
          icon: "agreement",
        },
        {
          name: "Master Services Agreement",
          url: "/categories/business/master-services-agreement",
          description:
            "The general agreement governing the relationship between a customer and a service provider defining each party's general obligations and responsibilities.",
          icon: "agreement",
        },
        {
          name: "Meeting Minutes",
          url: "/categories/business-formation/meeting_minutes",
          description:
            "Official records of an organization and are legally required for corporate meetings.",
          icon: "instructions",
        },
        {
          name: "Notice of Meeting",
          url: "/categories/business-formation/notice-of-meeting",
          description:
            " Use this notice to notify company owners, officers, or employees of an upcoming company meeting.",
          icon: "default",
        },
        {
          name: "Promissory Note",
          url: "/categories/business/promissory-note",
          description:
            " In a promissory note, a borrower promises to repay the other party in return for receiving money, goods, or services.",
          icon: "doc-sign",
        },
        {
          name: "Release of Liability Agreement",
          url: "/categories/business/release-of-liability",
          description:
            "Limits your legal and financial liability for injuries or damages.",
          icon: "agreement",
        },
        {
          name: "Security Agreement",
          url: "/categories/business/security-agreement",
          description:
            "Needed to obtain a security interest in collateral and can be used with a financing statement to register (or 'perfect') your interest with the state.",
          icon: "agreement",
        },
        {
          name: "Shareholder Agreement",
          url: "/categories/business-formation/shareholder-agreement",
          description:
            "Describes how the company should be operated and outlines shareholders' rights and obligations.",
          icon: "agreement",
        },
        {
          name: "Statement of Work",
          url: "/categories/business/statement-of-work",
          description:
            "By outlining clear terms, this agreement will help create reasonable expectations as well as avoid any unnecessary confusion.",
          icon: "instructions",
        },
        {
          name: "Stock Certificate ",
          url: "/categories/business-formation/stock-certificate",
          description:
            "Helps your company issue stock to shareholders and is used by shareholders as evidence of stock ownership.",
          icon: "doc-sign",
        },
        {
          name: "Stock Purchase Agreement",
          url: "/categories/business/stock-purchase-agreement",
          description:
            "Outlines the terms and conditions of a deal between someone who wants to invest money in a business or project and the person or entity who owns or runs it.",
          icon: "agreement",
        },
        {
          name: "Stock Transfer Ledger",
          url: "/categories/business-formation/stock-transfer-ledger",
          description:
            "Used to keep an accurate record of all of the corporation's stock transactions.",
          icon: "instructions",
        },
        {
          name: "Waiver and Release of Liability",
          url: "/categories/business/waiver-and-release-of-liability",
          description:
            " Create a waiver to release one or both parties involved in an event, dispute, contract, or other legal matter from liability (legal responsibility).",
          icon: "doc-signed",
        },
        {
          name: "Waiver of Notice",
          url: "/categories/business-formation/waiver-of-notice",
          description:
            "Voluntary statement used to waive the right to a formal meeting notice.",
          icon: "default",
        },
      ];
      return docs;
    },
  },
};
